<div class="visionboard-main">
  <merri-loading-spinner
    *ngIf="showLoading()"
    class="spinner"
    diameter="75"
    [loading]="showLoading()"
  ></merri-loading-spinner>
  <div
    class="workspaces"
    *ngIf="showWorkspace()"
  >
    <app-visionboard-workspace-freeform-container *ngIf="showFreeform()">
      <ng-template
        [ngTemplateOutlet]="controlsTemplate"
        workspace-controls
      ></ng-template>
    </app-visionboard-workspace-freeform-container>
    <app-visionboard-workspace-templates-container *ngIf="showTemplates()">
      <ng-template
        [ngTemplateOutlet]="controlsTemplate"
        workspace-controls
      ></ng-template>
    </app-visionboard-workspace-templates-container>
  </div>

  <div
    class="no-venues-warning"
    *ngIf="showNoVenueWarning()"
  >
    {{ missingEventDataMessage }}
  </div>

  <div
    class="small-screen-message"
    *ngIf="showSmallScreenWarning()"
  >
    <div>Mobile experience coming soon</div>
    <div>
      <button
        class="categories-mode-button"
        mat-stroked-button
        color="accent"
        (click)="onCategoriesModeClick()"
      >
        Switch to Category Vision Board
      </button>
    </div>
  </div>
</div>

<ng-template #controlsTemplate>
  <app-visionboard-workspace-controls></app-visionboard-workspace-controls>
</ng-template>

<ng-template #headerRightTemplate>
  <div class="header-right-container">
    <app-visionboard-workspace-actions-button-menu
      *appSkeleton="!showWorkspace() || vbLoading; height: '38px'; width: '36px'; borderRadius: '4px'"
    ></app-visionboard-workspace-actions-button-menu>
    <ng-container *ngIf="isShowroom">
      <app-showroom-preview-button
        *appSkeleton="!showWorkspace() || vbLoading; height: '38px'; width: '128px'; borderRadius: '4px'"
      ></app-showroom-preview-button>
      <app-showroom-show-templates-button *appSkeleton="!showWorkspace() || vbLoading; height: '38px'; width: '128px'; borderRadius: '4px'">
      </app-showroom-show-templates-button>
    </ng-container>
  </div>
</ng-template>

<ng-template #headerLeftTemplate>
  <app-visionboard-workspace-version-selector class="visionboard-version-selector"></app-visionboard-workspace-version-selector>
</ng-template>
